var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DisplayNameHandler_chatPlugin, _DisplayNameHandler_pubSub, _DisplayNameHandler_displayName, _DisplayNameHandler_storage, _DisplayNameHandler_unsubscribeFromStorage, _DisplayNameHandler_isDisplayNameValidCache, _DisplayNameHandler_onError;
import { displayNameRejectedError } from "./error";
export class DisplayNameHandler {
    constructor(chatPlugin, pubSub, storage, defaultDisplayName = null) {
        var _a;
        _DisplayNameHandler_chatPlugin.set(this, void 0);
        _DisplayNameHandler_pubSub.set(this, void 0);
        // Note that a display name set here isn't guaranteed to be valid
        _DisplayNameHandler_displayName.set(this, null);
        _DisplayNameHandler_storage.set(this, void 0);
        _DisplayNameHandler_unsubscribeFromStorage.set(this, void 0);
        // Keep track of whether display names are valid. This is useful, for a few things:
        //  - We can avoid additional network requests if we know a name is valid/invalid
        //  - We can explicitly signal a DisplayNameRejectedError if the user tries to
        //    send a message using a known invalid name
        //  - It helps reconcile (somewhat) the different name validation rules between
        //    PubNub and the plugin service. See:
        //    https://github.com/lazarentertainment/plugin-service/issues/562
        _DisplayNameHandler_isDisplayNameValidCache.set(this, new Map());
        this.getDisplayName = () => __classPrivateFieldGet(this, _DisplayNameHandler_displayName, "f");
        this.updateDisplayName = (name) => __awaiter(this, void 0, void 0, function* () {
            const trimmedName = name === null || name === void 0 ? void 0 : name.trim();
            if (!trimmedName) {
                __classPrivateFieldSet(this, _DisplayNameHandler_displayName, null, "f");
                __classPrivateFieldGet(this, _DisplayNameHandler_pubSub, "f").publish("displayName", null);
                return {
                    displayName: null,
                    isValid: true,
                };
            }
            const cachedIsDisplayNameValid = __classPrivateFieldGet(this, _DisplayNameHandler_isDisplayNameValidCache, "f").get(trimmedName);
            if (typeof cachedIsDisplayNameValid === "boolean") {
                if (cachedIsDisplayNameValid) {
                    __classPrivateFieldSet(this, _DisplayNameHandler_displayName, trimmedName, "f");
                    __classPrivateFieldGet(this, _DisplayNameHandler_pubSub, "f").publish("displayName", trimmedName);
                }
                return {
                    displayName: trimmedName,
                    isValid: cachedIsDisplayNameValid,
                };
            }
            const isValid = yield __classPrivateFieldGet(this, _DisplayNameHandler_chatPlugin, "f").validateDisplayName(trimmedName);
            __classPrivateFieldGet(this, _DisplayNameHandler_isDisplayNameValidCache, "f").set(trimmedName, isValid);
            if (isValid) {
                __classPrivateFieldGet(this, _DisplayNameHandler_storage, "f").setItem("displayName", trimmedName);
                __classPrivateFieldSet(this, _DisplayNameHandler_displayName, trimmedName, "f");
                __classPrivateFieldGet(this, _DisplayNameHandler_pubSub, "f").publish("displayName", trimmedName);
            }
            else {
                __classPrivateFieldGet(this, _DisplayNameHandler_pubSub, "f").publish("error", displayNameRejectedError(trimmedName));
            }
            return {
                displayName: trimmedName,
                isValid,
            };
        });
        _DisplayNameHandler_onError.set(this, (error) => {
            if (error.code === "DisplayNameRejectedError") {
                __classPrivateFieldGet(this, _DisplayNameHandler_isDisplayNameValidCache, "f").set(error.displayName, false);
            }
        });
        __classPrivateFieldSet(this, _DisplayNameHandler_chatPlugin, chatPlugin, "f");
        __classPrivateFieldSet(this, _DisplayNameHandler_pubSub, pubSub, "f");
        __classPrivateFieldSet(this, _DisplayNameHandler_storage, storage, "f");
        __classPrivateFieldSet(this, _DisplayNameHandler_unsubscribeFromStorage, storage.subscribe("displayName", (name) => this.updateDisplayName(name)), "f");
        pubSub.subscribe("error", __classPrivateFieldGet(this, _DisplayNameHandler_onError, "f"));
        __classPrivateFieldSet(this, _DisplayNameHandler_displayName, (_a = storage.getItem("displayName")) !== null && _a !== void 0 ? _a : defaultDisplayName, "f");
        storage.setItem("displayName", __classPrivateFieldGet(this, _DisplayNameHandler_displayName, "f"));
    }
    /**
     * Note that "not invalid" here does not imply "valid". This checks only that
     * we know some name is definitely invalid.
     */
    isDisplayNameInvalid(name) {
        return __classPrivateFieldGet(this, _DisplayNameHandler_isDisplayNameValidCache, "f").get(name) === false;
    }
    close() {
        __classPrivateFieldGet(this, _DisplayNameHandler_unsubscribeFromStorage, "f").call(this);
        __classPrivateFieldGet(this, _DisplayNameHandler_pubSub, "f").unsubscribe("error", __classPrivateFieldGet(this, _DisplayNameHandler_onError, "f"));
    }
}
_DisplayNameHandler_chatPlugin = new WeakMap(), _DisplayNameHandler_pubSub = new WeakMap(), _DisplayNameHandler_displayName = new WeakMap(), _DisplayNameHandler_storage = new WeakMap(), _DisplayNameHandler_unsubscribeFromStorage = new WeakMap(), _DisplayNameHandler_isDisplayNameValidCache = new WeakMap(), _DisplayNameHandler_onError = new WeakMap();
